export default class PlayerUrl {
  static fromRes(data) {
    return new PlayerUrl(data);
  }

  constructor(data) {
    this.url = data.url;
  }
}
